export default __webpack_public_path__ + "static/media/close.66b2aaa7.svg";